import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const GoogleLoginCallbackPage: React.FC = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { googleLoginWithCode } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const errorParam = params.get('error');
    if (errorParam) {
      setError(errorParam.replace(/_/g, ' '));
      return;
    }

    const code = params.get('code');
    if (!code) {
      setError('Missing authorization code.');
      return;
    }

    const state = params.get('state') || '';
    const decodedState = decodeURIComponent(state);
    const nextPath = decodedState.startsWith('/') ? decodedState : '/';
    const redirectUri = process.env.REACT_APP_GOOGLE_REDIRECT_URI || '';

    const completeLogin = async () => {
      const result = await googleLoginWithCode(code, redirectUri);
      if (result.success) {
        navigate(nextPath, { replace: true });
      } else {
        setError(result.message || 'Google login failed.');
      }
    };

    completeLogin();
  }, [search, googleLoginWithCode, navigate]);

  return (
    <div className="container py-5">
      <div className="text-center">
        {error ? (
          <Alert variant="danger">{error}</Alert>
        ) : (
          <>
            <Spinner animation="border" />
            <p className="mt-3 mb-0">Completing Google sign-in...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default GoogleLoginCallbackPage;
